import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
// イベントバスを使用してアプリケーション全体で更新通知を受け取るための実装
// カスタムイベントを定義
export const APP_UPDATE_EVENT = 'app-version-updated';
// 新しいバージョンの更新通知イベントを発火する関数
export const notifyAppUpdate = (version: string): void => {
  const event = new CustomEvent(APP_UPDATE_EVENT, { detail: { version } });
  window.dispatchEvent(event);
};
/**
 * アプリケーション更新通知用のコンポーネント
 * バージョン更新時に右下にSnackbarで通知を表示
 */
export const AppUpdateNotifier: React.FC = () => {
  const [ open, setOpen ] = useState(false);
  const [ version, setVersion ] = useState('');
  useEffect(() => {
    // イベントリスナーを登録
    const handleAppUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<{ version: string }>;
      setVersion(customEvent.detail.version);
      setOpen(true);
    };
    // イベントリスナーを登録
    window.addEventListener(APP_UPDATE_EVENT, handleAppUpdate);
    // セッションストレージから更新フラグをチェック (ページリロード後)
    const checkUpdateFlag = () => {
      const updated = sessionStorage.getItem('app_updated');
      if (updated) {
        try {
          const updateInfo = JSON.parse(updated);
          // 更新情報を表示
          setVersion(updateInfo.version);
          setOpen(true);
          // フラグを削除（一度だけ表示するため）
          sessionStorage.removeItem('app_updated');
        } catch (e) {
          // パース失敗時は何もしない
        }
      }
    };
    // ページロード時に更新フラグをチェック
    checkUpdateFlag();
    // クリーンアップ関数
    return () => {
      window.removeEventListener(APP_UPDATE_EVENT, handleAppUpdate);
    };
  }, []);
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
        新しいバージョン ( v{version} ) に更新しました
      </Alert>
    </Snackbar>
  );
};
export default AppUpdateNotifier;
